export default __webpack_public_path__ + "static/media/doorstep-pickup.07fff375.jpeg";